/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Subscription_Past_DueInputs */

const en_subscription_past_due = /** @type {(inputs: Subscription_Past_DueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Past Due`)
};

const fr_subscription_past_due = /** @type {(inputs: Subscription_Past_DueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`En retard de paiement`)
};

const de_subscription_past_due = /** @type {(inputs: Subscription_Past_DueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Überfällig`)
};

const it_subscription_past_due = /** @type {(inputs: Subscription_Past_DueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Scaduto`)
};

const ru_subscription_past_due = /** @type {(inputs: Subscription_Past_DueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Просрочено`)
};

const es_subscription_past_due = /** @type {(inputs: Subscription_Past_DueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vencido`)
};

const zh_cn2_subscription_past_due = /** @type {(inputs: Subscription_Past_DueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`逾期`)
};

const ja_subscription_past_due = /** @type {(inputs: Subscription_Past_DueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`支払期限超過`)
};

const hi_subscription_past_due = /** @type {(inputs: Subscription_Past_DueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`पिछला बकाया`)
};

const pt_pt2_subscription_past_due = /** @type {(inputs: Subscription_Past_DueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vencido`)
};

/**
* | output |
* | --- |
* | "Past Due" |
*
* @param {Subscription_Past_DueInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const subscription_past_due = /** @type {((inputs?: Subscription_Past_DueInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Subscription_Past_DueInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_subscription_past_due(inputs)
	if (locale === "de") return de_subscription_past_due(inputs)
	if (locale === "it") return it_subscription_past_due(inputs)
	if (locale === "ru") return ru_subscription_past_due(inputs)
	if (locale === "es") return es_subscription_past_due(inputs)
	if (locale === "zh-CN") return zh_cn2_subscription_past_due(inputs)
	if (locale === "ja") return ja_subscription_past_due(inputs)
	if (locale === "hi") return hi_subscription_past_due(inputs)
	if (locale === "pt-PT") return pt_pt2_subscription_past_due(inputs)
	return en_subscription_past_due(inputs)
});